<template>
  <div class="input-code">
    <BaseInput
      ref="BaseInputRef"
      class="input-code__input"
      text-center
      :value="value"
      :type="type"
      :has-error="hasError"
      :inputmode="isTypeNumber ? 'numeric' : 'text'"
      autocapitalize="none"
      autocomplete="off"
      spellcheck="false"
      autocorrect="off"
      :pattern="pattern"
      :maxlength="codeLength"
      @input="onInput($event)"
    />
  </div>
</template>
<script>
import BaseInput from '~/components/Base/Input'

export default {
  name: 'BaseInputCode',
  components: { BaseInput },
  props: {
    value: { type: String },
    codeLength: { type: Number, default: 6 },
    regexp: { type: RegExp }, // what exclude
    type: { type: String, default: 'string' },
    focus: { type: Boolean },
    hasError: { type: Boolean },
  },
  computed: {
    isTypeNumber() {
      return this.type === 'number'
    },
    pattern() {
      return this.isTypeNumber ? '[0-9]' : '[a-z0-9]'
    },
  },
  watch: {
    focus(val) {
      if (val) {
        this.$nextTick(() => {
          this.$addFocus()
        })
      }
    },
  },
  mounted() {
    if (this.focus) {
      this.$nextTick(() => {
        this.$addFocus()
      })
    }
  },
  methods: {
    onInput(value) {
      const cleanValue = value.trim().replace(this.regexp, '').slice(0, this.codeLength)
      this.$refs.BaseInputRef.getInput().value = cleanValue
      if (cleanValue.length <= this.codeLength && cleanValue !== this.value) {
        this.$emit('input', cleanValue)
      }
      
      if (cleanValue.length === this.codeLength && cleanValue !== this.value) {
        this.$emit('filled', cleanValue)
      }
    },

    $addFocus() {
      this.$refs.BaseInputRef?.addFocus()
    },
  },
}
</script>
<style lang="scss" src="./style.scss" scoped />
